import "./App.css";
import { useState, useEffect } from "react";
import { getWeatherData } from "./data/weather";
import { getWeatherWarningsByLatLon } from "./data/alerts";
import Time from "./components/Time";
import Temp from "./components/Temp";
import WeatherDetails from "./components/WeatherDetails";

const WEATHER_PULL_INTERVAL = 5 * 60 * 1000; // 5 minutes in milliseconds

function updateInfo(
  setAppClass,
  setTemp,
  setHigh,
  setLow,
  setDescription,
  setFontColor,
  setWarnings
) {
  getWeatherData().then((data) => {
    let background = data.current.background;
    if (background) {
      setAppClass(`App ${background}`);
    }
    let temp = Math.round(data.current.temperature2m);
    let high = Math.round(data.daily.temperature2mMax);
    let low = Math.round(data.daily.temperature2mMin);
    setTemp(`${temp}°`);
    setHigh(`${high}°`);
    setLow(`${low}°`);
    setDescription(data.current.description);
    setFontColor(data.current.font_color);
  });

  getWeatherWarningsByLatLon().then((warnings) => {
    setWarnings(warnings || []);
  });
}

export default function App() {
  const [appClass, setAppClass] = useState("App");
  const [temp, setTemp] = useState("--");
  const [high, setHigh] = useState("--");
  const [low, setLow] = useState("--");
  const [description, setDescription] = useState("");
  const [fontColor, setFontColor] = useState("white");
  const [warnings, setWarnings] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    // Initial fetch
    updateInfo(
      setAppClass,
      setTemp,
      setHigh,
      setLow,
      setDescription,
      setFontColor,
      setWarnings
    );

    // Set up interval for periodic updates
    const interval = setInterval(
      () =>
        updateInfo(
          setAppClass,
          setTemp,
          setHigh,
          setLow,
          setDescription,
          setFontColor,
          setWarnings
        ),
      WEATHER_PULL_INTERVAL
    );

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);

  const enterFullscreen = () => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    }
  };

  return (
    <div className={appClass}>
      {!isFullscreen && (
        <button className="fullscreen-button" onClick={enterFullscreen}>
          ⛶
        </button>
      )}
      <WeatherDetails
        description={description}
        fontColor={fontColor}
        warnings={warnings}
      />
      <div className="">
        <header className="App-header" style={{ color: fontColor }}>
          <Time />
          <Temp temp={temp} high={high} low={low} />
        </header>
      </div>
    </div>
  );
}
